/* global newrelic */
import { setState, getState } from '../state';

export const dataSources = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('data-sources.data', ({ output }) => {
    const { variables: { itemId }, data } = output;
    if (itemId) {
      const products = {
        [itemId]: data,
        currentItemId: itemId
      };
      setState({ products });
    }

  });

  window.LIFE_CYCLE_EVENT_BUS.on('data-sources.error', ({ output }) => {
    const message = output?.data?.message;
    if (typeof newrelic !== 'undefined' && message) {
      newrelic.noticeError(message);
    }
  });
};
